<template>
  <footer class="px-4 divide-y dark:bg-gray-100 dark:text-gray-800">
    <div class="container flex flex-col justify-between py-10 mx-auto space-y-8 lg:flex-row lg:space-y-0">
      <!-- Logo and Title -->
      <div class="lg:w-1/3">
        <router-link to="/" class="flex justify-center space-x-3 lg:justify-start">
          <div class="flex items-center justify-center w-64 h-64 rounded-full dark:bg-emerald-600">
            <img src="@/assets/logo.png" alt="" class="object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 rounded-xl">
          </div>
        </router-link>
      </div>

      <!-- Navigation Links -->
      <div class="grid grid-cols-2 text-sm gap-x-3 gap-y-8 lg:w-2/3 sm:grid-cols-3">
        <div class="space-y-3">
          <h3 class="tracking-wide uppercase dark:text-gray-900">Explore</h3>
          <ul class="space-y-1">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/about">About</router-link></li>
            <li><router-link to="/quests">Quests</router-link></li>
            <li><router-link to="/nft">NFT</router-link></li>
            <li><router-link to="/staking">Staking</router-link></li>
            <li><router-link to="/join">Join Us</router-link></li>
          </ul>
        </div>
        <div class="space-y-3">
          <h3 class="tracking-wide uppercase dark:text-gray-900">Resources</h3>
          <ul class="space-y-1">
            <li><router-link to="/faq">FAQ</router-link></li>
            <li><router-link to="/guides">Guides</router-link></li>
          </ul>
        </div>
        <div class="space-y-3">
          <h3 class="tracking-wide uppercase dark:text-gray-900">Social Media</h3>
          <div class="flex space-x-3">
            <!-- Telegram -->
            <a href="https://t.me/untouchable_guys" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-200 hover:bg-emerald-500">
              <img src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png" alt="Telegram" class="w-5 h-5">

            </a>
            <!-- X -->
            <a href="https://x.com/UntachableGuys" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-200 hover:bg-emerald-500">
              <img src="@/assets/x.png"
                    alt="X" class="w-5 h-5">
            </a>
            <!-- DexScreener -->
            <a href="https://dexscreener.com" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-200 hover:bg-emerald-500">
              <img src="@/assets/dex-screener-seeklogo.png" alt="DexScreener" class="w-5 h-5">
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="py-6 text-sm text-center dark:text-gray-600">
      © {{ new Date().getFullYear() }} The Chosen One. All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooTer",
};
</script>
